import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/esg/double-materiality/$assessmentId/')({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/esg/double-materiality/$assessmentId/overview',
      params: { assessmentId: params.assessmentId },
      replace: true,
    });
  },
});
